import { useEffect, useState, useContext } from "react";
import { Wrapper, DatabaseSearchContext } from "nystem-components";
import app from "nystem";

const ViewButtonEventSum = ({ value, model }) => {
  const [sum, setSum] = useState(false);
  const [stat, setStat] = useState();
  const { className, renderAs } = model;
  const { search } = useContext(DatabaseSearchContext);

  useEffect(() => {
    const { event, fieldType } = model;
    if (!["total", "searchTotal"].includes(fieldType)) return;
    let haveSet = false;

    const update = async ({ value }) => {
      if (!haveSet) haveSet = true;
      return { value: parseFloat(search[fieldType]) + value };
    };

    app.on(event, fieldType === "sum" ? -10 : 0, update);

    const timer = setTimeout(() => {
      if (haveSet) return;

      haveSet = true;
      app.event(event, { value: 0 });
    }, 200);

    return () => {
      clearTimeout(timer);
      app.off(event, update);
    };
  }, [model, search]);

  useEffect(() => {
    const { event, field, fieldType } = model;
    if (!["field"].includes(fieldType)) return;

    let haveSet = false;

    const update = async ({ value: val }) => {
      if (!haveSet) haveSet = true;
      return { value: parseFloat(value[field]) + val };
    };

    app.on(event, update);

    const timer = setTimeout(() => {
      if (haveSet) return;

      haveSet = true;
      app.event(event, { value: 0 });
    }, 200);

    return () => {
      clearTimeout(timer);
      app.off(event, update);
    };
  }, [model, value]);

  useEffect(() => {
    const { event, fieldType } = model;
    if (!["sum"].includes(fieldType)) return;
    let haveSet = false;

    const update = async ({ value }) => {
      if (!haveSet) haveSet = true;
      setSum(value);
    };

    app.on(event, -10, update);

    const timer = setTimeout(() => {
      if (haveSet) return;

      haveSet = true;
      app.event(event, { value: 0 });
    }, 200);

    return () => {
      clearTimeout(timer);
      app.off(event, update);
    };
  }, [model]);

  useEffect(() => {
    if (model.fieldType !== "neverActiveUsers") return;

    let mounted = true;

    (async () => {
      if (search.isDirty || !search.filter) return;

      const baseFilter = app.clone(search.filter);
      const hasFailedFilter = baseFilter.$and?.some(
        (item) => item.status === "failed",
      );

      if (!hasFailedFilter) {
        setStat();
        return;
      }

      await app.delay(0);

      const { data: subscriptions } = await app.database.subscription.search({
        exact: search.exact,
        filter: baseFilter,
        count: model.maxCount || 10000,
        position: 0,
      });

      if (!mounted) return;

      const failedUserIds = [
        ...new Set((subscriptions || []).map((item) => item.user).filter(Boolean)),
      ];

      if (!failedUserIds.length) {
        setStat({ count: 0, reasons: [] });
        return;
      }

      await app.delay(0);

      const activeFilter = app.clone(search.filter);

      activeFilter.$and = (activeFilter.$and || [])
        .filter((item) => !Object.prototype.hasOwnProperty.call(item, "status"))
        .concat({ status: "active" }, { user: failedUserIds });

      const { data: activeSubscriptions } =
        await app.database.subscription.search({
          filter: activeFilter,
          count: failedUserIds.length,
          position: 0,
        });

      if (!mounted) return;

      const activeUsers = new Set(
        (activeSubscriptions || []).map((item) => item.user).filter(Boolean),
      );
      const usersByReason = {};
      const newestFailedByUser = {};

      (subscriptions || []).forEach((item) => {
        if (!item.user || activeUsers.has(item.user)) return;

        const at = newestFailedByUser[item.user];
        const itemDate = item._chdate || item._crdate || 0;
        const atDate = at?._chdate || at?._crdate || 0;

        if (!at || itemDate > atDate) newestFailedByUser[item.user] = item;
      });

      Object.values(newestFailedByUser).forEach((item) => {
        const reason = item.refusalReason || model.emptyReasonText || "No reason";
        usersByReason[reason] = (usersByReason[reason] || 0) + 1;
      });

      setStat({
        count: Object.keys(newestFailedByUser).length,
        reasons: Object.entries(usersByReason)
          .sort((a, b) => b[1] - a[1])
          .slice(0, model.reasonCount || 3),
      });
    })();

    return () => {
      mounted = false;
    };
  }, [model, search]);

  if (model.fieldType === "neverActiveUsers" && !stat) return null;

  if (model.fieldType === "neverActiveUsers")
    return (
      <Wrapper className={className} renderAs={renderAs}>
        <Wrapper renderAs="span">{`${model.text || "Never active"}: ${
          stat?.count || 0
        }`}</Wrapper>
        {stat?.reasons?.length ? (
          <Wrapper className={model.reasonClassName}>
            {stat.reasons.map(([reason, count]) => (
              <Wrapper key={reason} renderAs="div">
                {`${reason}: ${count}`}
              </Wrapper>
            ))}
          </Wrapper>
        ) : null}
      </Wrapper>
    );

  if (value === false) return null;

  return (
    <Wrapper className={className} renderAs={renderAs}>
      {sum}
    </Wrapper>
  );
};

export default ViewButtonEventSum;
